"use strict";
if (typeof angular !== "undefined") {
    window.ppMigrationApp = angular.module('ppMigrationApp', ['ngMessages', 'ngAnimate'])
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.debugInfoEnabled(false);
        }]);
    window.ppMigrationApp.config(['$interpolateProvider', function ($interpolateProvider) {
            $interpolateProvider.startSymbol('{[{').endSymbol('}]}');
        }]);
    window.ppMigrationApp.controller('pageController', ['$scope', function ($scope) {
            $scope.units = 1;
            $scope.hasErrors = function (errors) {
                return !angular.equals({}, errors);
            };
        }]);
    angular.element(document).ready(function () {
        var appDiv = document.getElementById('page');
        angular.bootstrap(angular.element(appDiv), ['ppMigrationApp', 'ngMessages']);
    });
}
